import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthSkeleton, RegisterForm } from '../layout';

const Register: FC = () => {
  const { t } = useTranslation('register');
  return (
    <AuthSkeleton
      pageTitle={t('page_title')}
      title={t('meta_title')}
      subtitle={t('meta_subtitle')}
      reverse
    >
      <RegisterForm />
    </AuthSkeleton>
  );
};

export default Register;
